import styled from 'react-emotion';
import { ListItem } from '@material-ui/core';
import { theme, styleUtils } from '@ublend-npm/aulaui-next';

export const StaffSpacesContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: ${theme.spacing.small};
  padding-left: ${theme.spacing.xLarge};
  padding-bottom: ${theme.spacing.large};
  padding-right: ${theme.spacing.xLarge};
`;

export const PrimaryTextContainer = styled.div`
  padding: 0;
  padding-bottom: ${theme.spacing.large};
  min-height: 32px;
  display: flex;
  align-items: center;
  font-family: Work Sans;
  font-family: ${theme.font.family.workSans};
  font-size: 20px;
  font-weight: ${theme.font.weight.semiBold};
  line-height: ${theme.font.lineHeight.large};
  width: calc(100% - 80px);
`;

export const SecondaryListItem = styled(ListItem)`
  color: ${theme.color.designSystem.purple70};
  padding: 0;
  margin-top: 0;
  width: fit-content;
  border-radius: 4px;
  & > div {
    color: ${theme.color.designSystem.purple70};
  }
  :hover {
    background-color: ${styleUtils.color.opacity({
      color: 'purple',
      alpha: 'alpha8',
    })};
  }
  cursor: pointer;
  margin-bottom: ${theme.spacing.xLarge};
`;

export const SecondaryText = styled.span`
  font-family: ${theme.font.family.workSans};
  font-size: ${theme.font.size.copy};
  font-weight: ${theme.font.weight.bold};
  line-height: ${theme.font.lineHeight.copy};
  color: ${theme.color.designSystem.purple70};
`;

export const AvatarContainer = styled('div')`
  margin-right: ${theme.spacing.medium};
`;

export const GrayText = styled.span`
  font-family: ${theme.font.family.workSans};
  font-size: ${theme.font.size.copy};
  line-height: ${theme.font.lineHeight.copy};
  color: ${theme.color.designSystem.blackOpacity60};
  padding-top: ${theme.spacing.xxLarge};
  max-width: 60%;
  display: flex;
  align-self: center;
`;

export const ArchiveToggleContainer = styled.div`
  margin-top: 5px;
  margin-bottom: 5px;
`;
